import React from 'react';
import { useTranslation } from 'react-i18next';

const TermsOfService = () => {
    const { t } = useTranslation();

    return (
        <div className="prose prose-invert max-w-none">
            <h1 className="text-center">{t('termsOfService.title')}</h1>
            <p className="text-sm text-center text-red-400 font-bold">{t('termsOfService.disclaimer')}</p>

            <h2>{t('termsOfService.acceptance.title')}</h2>
            <p>{t('termsOfService.acceptance.content')}</p>

            <h2>{t('termsOfService.userAccounts.title')}</h2>
            <p>{t('termsOfService.userAccounts.content')}</p>

            <h2>{t('termsOfService.inAppCurrency.title')}</h2>
            <p>{t('termsOfService.inAppCurrency.description')}</p>
            <ul>
                <li><strong>{t('termsOfService.inAppCurrency.noRealWorldValue.title')}</strong> {t('termsOfService.inAppCurrency.noRealWorldValue.content')}</li>
                <li><strong>{t('termsOfService.inAppCurrency.allPurchasesFinal.title')}</strong> {t('termsOfService.inAppCurrency.allPurchasesFinal.content')}</li>
                <li><strong>{t('termsOfService.inAppCurrency.cashOutFeature.title')}</strong> {t('termsOfService.inAppCurrency.cashOutFeature.content')}</li>
                <li><strong>{t('termsOfService.inAppCurrency.fraud.title')}</strong> {t('termsOfService.inAppCurrency.fraud.content')}</li>
            </ul>

            <h2>{t('termsOfService.chargebacks.title')}</h2>
            <p>{t('termsOfService.chargebacks.content')}</p>

            <h2>{t('termsOfService.userContent.title')}</h2>
            <p>{t('termsOfService.userContent.content')}</p>

            <h2>{t('termsOfService.prohibitedConduct.title')}</h2>
            <p>{t('termsOfService.prohibitedConduct.description')}</p>
            <ul>
                <li>{t('termsOfService.prohibitedConduct.harassing')}</li>
                <li>{t('termsOfService.prohibitedConduct.illegalContent')}</li>
                <li>{t('termsOfService.prohibitedConduct.illegalPurpose')}</li>
                <li>{t('termsOfService.prohibitedConduct.interference')}</li>
            </ul>

            <h2 className="text-red-400">Zero Tolerance Policy for Objectionable Content & Abusive Users</h2>
            <p>
                In accordance with app store guidelines, Whispers of Harmony maintains a strict, zero-tolerance policy against objectionable content and abusive users. 
                By using this app, you agree that you will not post content that is defamatory, offensive, harassing, illegal, or otherwise inappropriate.
            </p>
            <ul>
                <li><strong>Reporting:</strong> Users can report objectionable content or abusive users directly within the app using the "Report" button on posts and profiles. Our moderation team reviews reports within 24 hours.</li>
                <li><strong>Blocking:</strong> You may block any user from interacting with you or seeing your content by using the "Block User" feature on their profile.</li>
                <li><strong>Action Taken:</strong> Any user found violating these terms will face immediate suspension or permanent banning from the platform without prior notice. Any objectionable content will be removed immediately upon discovery or after a valid report.</li>
            </ul>

            <h2>{t('termsOfService.intellectualProperty.title')}</h2>
            <p>{t('termsOfService.intellectualProperty.content')}</p>

            <h2>{t('termsOfService.disclaimers.title')}</h2>
            <p>{t('termsOfService.disclaimers.content')}</p>

            <h2>{t('termsOfService.governingLaw.title')}</h2>
            <p>{t('termsOfService.governingLaw.content', { state: '[Your State]', city: '[Your City]' })}</p>
        </div>
    );
};

export default TermsOfService;
